/**
 * Created with setting-lib codegen.
 */
import { featureToggle } from "@faire/web/common/settings/declarations/featureToggle";

/**
 * Controls whether [feature] is enabled.
 */
export const FE_UNSUB_BY_MARKETING_TYPE_241213 = featureToggle({
  name: "FE_UNSUB_BY_MARKETING_TYPE_241213",
  identifier: "RetailerTokenInSession",
  client: "RETAILER",
  notifyAfter: "2025-01-30",
  productArea: "BRAND_CRM",
});
